(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBA(root) {
    if (root.dataset.baInit === '1') return;
    root.dataset.baInit = '1';
    var handle = root.querySelector('[data-boost-ba-handle]');
    var dragging = false;

    function setPos(clientX) {
      var r = root.getBoundingClientRect();
      var p = ((clientX - r.left) / r.width) * 100;
      p = Math.max(0, Math.min(100, p));
      root.style.setProperty('--pos', p + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
    }

    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
      setPos(e.clientX);
    });
    root.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    root.addEventListener('pointerup', function () { dragging = false; });
    root.addEventListener('pointercancel', function () { dragging = false; });

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(root).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { e.preventDefault(); root.style.setProperty('--pos', Math.max(0, cur - 3) + '%'); handle.setAttribute('aria-valuenow', Math.round(Math.max(0, cur - 3))); }
        if (e.key === 'ArrowRight') { e.preventDefault(); root.style.setProperty('--pos', Math.min(100, cur + 3) + '%'); handle.setAttribute('aria-valuenow', Math.round(Math.min(100, cur + 3))); }
      });
    }
  }

  function initAll() { document.querySelectorAll('[data-boost-ba]').forEach(initBA); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-boost-ba]');
    if (el) initBA(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boost-video-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBoostVSP(root) {
    if (root.dataset.boostVspInit === '1') return;
    root.dataset.boostVspInit = '1';

    var track    = root.querySelector('[data-boost-vsp-track]');
    var prevBtn  = root.querySelector('[data-boost-vsp-prev]');
    var nextBtn  = root.querySelector('[data-boost-vsp-next]');
    var autoplay = root.dataset.autoplay !== 'false';
    var threeD   = root.dataset.threed === 'true';
    var videos   = root.querySelectorAll('[data-boost-vsp-video]');

    // ---- Effet 3D : la carte s'incline vers le curseur ----
    if (threeD && window.matchMedia('(hover: hover)').matches) {
      root.querySelectorAll('.boost-vsp__card').forEach(function (card) {
        var media = card.querySelector('.boost-vsp__media');
        if (!media) return;
        card.addEventListener('mousemove', function (e) {
          var r = media.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          media.style.transform =
            'rotateY(' + (px * 12) + 'deg) rotateX(' + (-py * 12) + 'deg) translateY(-6px) scale(1.03)';
        });
        card.addEventListener('mouseleave', function () {
          media.style.transform = '';
        });
      });
    }

    // ---- Défilement flèches ----
    function scrollAmount() {
      var card = track.querySelector('.boost-vsp__card');
      var gap  = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 24, 10) || 24;
      return card ? (card.offsetWidth + gap) : 260;
    }
    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // ---- Bouton son : un seul non-muet à la fois ----
    function muteAll(except) {
      videos.forEach(function (v) {
        if (v === except) return;
        v.muted = true;
        var btn = v.parentNode.querySelector('[data-boost-vsp-sound]');
        if (btn) {
          btn.classList.add('is-muted');
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Activer le son');
        }
      });
    }

    videos.forEach(function (video) {
      var soundBtn = video.parentNode.querySelector('[data-boost-vsp-sound]');
      if (!soundBtn) return;
      soundBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.muted) {
          muteAll(video);
          video.muted = false;
          if (video.paused) { video.play().catch(function () {}); }
          soundBtn.classList.remove('is-muted');
          soundBtn.setAttribute('aria-pressed', 'true');
          soundBtn.setAttribute('aria-label', 'Couper le son');
        } else {
          video.muted = true;
          soundBtn.classList.add('is-muted');
          soundBtn.setAttribute('aria-pressed', 'false');
          soundBtn.setAttribute('aria-label', 'Activer le son');
        }
      });
    });

    // ---- Autoplay au scroll (IntersectionObserver) ----
    if (autoplay && videos.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              var p = video.play();
              if (p && p.catch) { p.catch(function () {}); }
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.5, 1] });
        videos.forEach(function (v) { io.observe(v); });
      } else {
        // Fallback navigateurs anciens : on lance tout en muet
        videos.forEach(function (v) { v.play().catch(function () {}); });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-boost-vsp]').forEach(initBoostVSP);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Compatibilité éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-boost-vsp]');
    if (el) initBoostVSP(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    if (root.dataset.faqInit === '1') return;
    root.dataset.faqInit = '1';
    var single = root.dataset.single === 'true';
    var items = root.querySelectorAll('.boost-faq__item');

    root.querySelectorAll('[data-boost-faq-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.boost-faq__item');
        var isOpen = item.classList.contains('is-open');
        if (single && !isOpen) {
          items.forEach(function (it) {
            it.classList.remove('is-open');
            var b = it.querySelector('[data-boost-faq-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-boost-faq]').forEach(initFaq); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-boost-faq]');
    if (el) initFaq(el);
  });
  // Ouvrir l'item sélectionné dans l'éditeur de thème
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.boost-faq__item');
    if (item) {
      item.classList.add('is-open');
      var b = item.querySelector('[data-boost-faq-btn]');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truspilot"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBoostRev(root) {
    if (root.dataset.boostRevInit === '1') return;
    root.dataset.boostRevInit = '1';

    var track = root.querySelector('[data-boost-rev-track]');
    var prev  = root.querySelector('[data-boost-rev-prev]');
    var next  = root.querySelector('[data-boost-rev-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.boost-rev__card');
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20, 10) || 20;
      return card ? (card.offsetWidth + gap) : 340;
    }
    function update() {
      if (!prev && !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() { document.querySelectorAll('[data-boost-rev]').forEach(initBoostRev); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-boost-rev]');
    if (el) initBoostRev(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
